import { moaService } from '../../helpers/services/productMoa.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, sessionHelper } from '@/utils'
import { SESSION } from "@/constants";
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRODUT_MOA_MODULE = 'productMoa';

// define action 
export const GET_ALL_PRODUCT_MOAS = 'getAllProductMoas';
export const GET_PRODUCT_MOA = 'getProductMoa';
export const UPDATE_PRODUCT_MOA = 'updateProductMoa';
export const CREATE_PRODUCT_MOA = 'createProductMoa';
export const UPDATE_PRODUCT_MOA_STATUS = 'updateProductMoaStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRODUCT_MOAS_REQUEST = "getAllProductMoas";
const GET_PRODUCT_MOA_REQUEST = "getProductMoa";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PRODUCT_MOAS]({ commit }, { filter }) {
        await moaService
            .getAllMoas(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRODUCT_MOAS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_PRODUCT_MOA]({ commit }, { id }) {
        moaService
            .getMoa(id)
            .then(
                (result) => {
                    commit(GET_PRODUCT_MOA_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_MOA]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        moaService
            .updateMoa(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.productMoa')]);
                    if (isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_MOA]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        moaService
            .createMoa(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.createXSuccess", [i18n.t('module.productMoa')]);
                    if (isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_MOA_STATUS]({ dispatch }, { filter, data }) {
        moaService
            .updateMoaStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCT_MOAS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state, isCloseWhenSuccess) {
        state.status = {};
        if (isCloseWhenSuccess == false) {
            router.push({ name: "Product-moa-listing" });
        }
        else {
            sessionHelper.clearSearch(SESSION.PRODUCT_SPECIAL_SEARCH)
        }
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRODUCT_MOAS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at),
                moa: o.moa,
                product: o.product,
            }
        })
    },
    [GET_PRODUCT_MOA_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            moa: o.moa,
            product: o.product,
            productID: o.product != null ? {
                value: o.product.uuid,
                text: o.product.name
            } : '',
            moaID: o.moa != null ? {
                value: o.moa.uuid,
                text: o.moa.name
            } : '',
        }

    }
}


